import { UsuarioService } from "./../../../services/usuario/usuario.service";
import { FormGroup, FormControl, Validators, NgForm } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { Usuario } from "../../../models/usuario";
import { Router } from "@angular/router";
import { EmailService } from "./../../../services/email/email.service";
import { SocketioService } from "src/app/services/socketio.service";
import { environment } from "src/environments/environment";
import { CronometrotiempoService } from "src/app/services/cronometro/cronometrotiempo.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  formausuario: FormGroup;
  nombreusuarioactivo = "";
  usuariobot: string;
  firmabotdia = false;
  firmabotsemana = false;
  firmabotmes = false;
  firmabotano = false;
  firmaexcursion = false;
  emailRecordado = '';
  recordarUsuario = false;

  constructor(
    public _usuarioService: UsuarioService,
    public router: Router,
    public emailService: EmailService,
    private socketService: SocketioService,
    private cronometrotiempoService: CronometrotiempoService
  ) {}

  ngOnInit() {
    this.emailRecordado = localStorage.getItem('emailRecordado') || '';
    this.recordarUsuario = this.emailRecordado !== '';
    this.formausuario = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email]),
      password: new FormControl(null, Validators.required),
      password2: new FormControl(null, Validators.required),
    });
  }

  ingresar(forma: NgForm) {
    if (forma.invalid) {
      return;
    }

    const usuario = new Usuario(
      null,
      null,
      forma.value.email,
      "",
      null,
      forma.value.password
    );

    this._usuarioService
      .login(usuario, forma.value.recuerdame)

      .subscribe((resp) => {
        if (resp.ok === false) {
          alert ("todo mal");
        } else {
 const nombrempresa = resp;

  
        //  console.log ('muestra todo',resp );
        // const idsolicitate = localStorage.getItem('usuario{nombreEmpresa}');

        //  this.cronometrotiempoService.disparadorCronometro.emit ({data: 1});
        let cronometrosidebar = {
          hor: 0,
          min: 0,
          seg: 1,
        };

        localStorage.setItem(
          "cronometrosider",
          JSON.stringify(cronometrosidebar)
        );

        this.nombreusuarioactivo = this._usuarioService.nombreempresa;
        this.usuariobot = this._usuarioService.alias;

        if (this._usuarioService.usuarioLogin.role == "USER_SPORTFISHING") {
          // this._usuarioService.actualiza_bot(true,this._usuarioService.)
          // this.socketService.emit('bot_logueado', true );

          const payload = {
            id: this._usuarioService.usuarioLogin._id,
            statusactivacion: "enLinea",
          };
          this.socketService.emit("usuarios_sportfishing", payload);
        }

        localStorage.setItem(
          "bottemporal",
          "temporalbot606dbf7e974SMX756c863f7"
        );

        if (nombrempresa.indexOf("SPORTFISHING") !== -1) {
          localStorage.setItem("pagina", "sportfishingmx");
          this.router.navigate(["main"]);

          // ahora se enviara el nombre del bot al servidor para que lo propgage en todos lso servidores

          const payload = {
            nombreusuario: this.usuariobot,
            color: this._usuarioService.colorpersonal,
          };
          this.socketService.emit("botsmx", payload);

          //        this.avisoasesorentrando();
        } else if (nombrempresa.indexOf("LANDING") !== -1) {
          localStorage.setItem("pagina", "landing");
          
          this.router.navigate(["landing"]);

          if (environment.sonarAlarma) {
            // se le quito el envio de email ponioenodlo en comentarios
            this.enviaemail();
          }
        } else if (nombrempresa.indexOf("GESTOR") !== -1) {
          localStorage.setItem("pagina", "GESTOR");
          this.router.navigate(["gestoresmenu"]);
          if (environment.sonarAlarma) {
            this.enviaemail();
          }
        }
        }


       
      });
  }

  enviaemail() {
    // const nombreArchivocompleto = this.nombreArchivoPDF;
    const subJet =
      this.nombreusuarioactivo + " ha entrado al modulo de compras";

    // const direccionemail = this.txtemail;
    //   const filepdf = nombreArchivocompleto;

    //  this.nombreArchivoPDF = filepdf;
    this.emailService.sendEmailTuripes(subJet).subscribe((licen) => {
      // alert ('listo');
      // this.botonFinalizadeshabilitado = false;
    });
  }

  avisoasesorentrando() {
    // const nombreArchivocompleto = this.nombreArchivoPDF;
    const subJet =
      "Asesor Sportfishing : " +
      this._usuarioService.nombredelusuario +
      " a entrado a MX";

    // const direccionemail = this.txtemail;
    //   const filepdf = nombreArchivocompleto;

    //  this.nombreArchivoPDF = filepdf;
    this.emailService.sendEmailTuripes(subJet).subscribe((licen) => {
      // alert ('listo');
      // this.botonFinalizadeshabilitado = false;
    });
  }
}
